var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4969 24.5585V14.5156L11.4883 16.3987",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.50643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5156 23.931C18.0402 24.325 18.6921 24.5585 19.3987 24.5585C21.1319 24.5585 22.5371 23.1534 22.5371 21.4201C22.5371 19.6868 21.1319 18.2817 19.3987 18.2817C18.6921 18.2817 18.0402 18.5152 17.5156 18.9091L18.1433 14.5156H22.5371",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.50643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.102 8.91186C31.781 14.1728 32.0917 23.0112 26.7959 28.653C21.5001 34.2947 12.6033 34.6033 6.92427 29.3423C1.24523 24.0813 0.93455 15.243 6.23033 9.60123C9.24258 6.39221 13.4199 4.90863 17.5074 5.19402M15.5088 1.96191L19.0899 5.35412L15.5088 8.99192",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 2.51072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.6d7479a606bdca7f3687939423f4f34e.svg";
export { ForwardRef as ReactComponent };